// extracted by mini-css-extract-plugin
module.exports = {"profileIcon":"styles_profileIcon__39wz4","profileIconWrapper":"styles_profileIconWrapper__2NMke","profileIconActive":"styles_profileIconActive__1VwzV"};